import React, { useState } from "react";
import { Row, Col } from "react-bootstrap";
import CustomAlert from "../../shared/CustemAlert";
import useAxiosPrivate from "../../../hooks/useAxiosPrivate";
import HandleHttpErrors from "../../HandleHttpErrors";
const baseURL = process.env.REACT_APP_API;

export default function Add({ increment, counter, jobtypesList }) {
  const [title, setTitle] = useState(""); // useState hook
  const [error, setError] = useState(false);
  const [isAdded, SetIsAdded] = useState(false);
  const axiosPrivate = useAxiosPrivate();
  const [newJob, setNewJob] = useState({
    jobtype: 0,
    title: "",
  });

  // handle change event
  const handleChange = (e) => {
    e.preventDefault(); // prevent the default action
    const { name, value } = e.target;
    if (name === "active") {
      setNewJob((prevState) => ({
        ...prevState,
        active: e.target.checked,
      }));
    } else
      setNewJob((prevState) => ({
        ...prevState,
        [name]: value,
      }));
  };
  const handleDDSChange = (e) => {
    e.preventDefault();
    const { name, value } = e.target;
    const n = Number(value);
    setNewJob((prevState) => ({
      ...prevState,
      [name]: n,
    }));
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    let isMounted = true;
    const controller = new AbortController();

    const postData = async () => {
      try {
        const response = await axiosPrivate.post(
          baseURL + "jobs/job/",
          newJob,
          {
            signal: controller.signal,
          }
        );
        SetIsAdded(true);
        isMounted && increment();
      } catch (err) {
        if (err.response) {
          alert(HandleHttpErrors(err.response.status));
          console.log(err.response);
        } else if (err.request) {
          alert(
            " The client never received a response, and the request was never left"
          );
          console.log(err.request);
        } else {
          alert(" Anything else");
        }
      }
    };
    postData();
    setTitle("");
    setError(false);
  };
  // render

  return (
    <div>
      <center>
        <div className="card text-dark bg-light container p-3 border  ">
          <div className="card-header">
            <h2>תפקידים</h2>
            <a
              style={{
                color: "red",
                backgroundColor: "transparent",
                textDecoration: "none",
              }}
              href="https://www.gov.il/he/Departments/DynamicCollectors/role-descriptions?skip=0"
              target="_blank"
              rel="noopener noreferrer"
            >
              קישור לרשימת התפקידים במשרד הפנים
            </a>
          </div>
          <div className="card-body">
            <Row>
              <Col>
                <form onSubmit={handleSubmit} className="mbsc-form-group">
                  <div className="form-group">
                    <label htmlFor="title">תפקיד </label>
                    <input
                      type="text"
                      name="title"
                      value={newJob.title}
                      onChange={handleChange}
                      className="form-control"
                      id="title"
                      placeholder="תקליד שם מלא"
                    />
                  </div>
                  <br />
                  <div className="form-group">
                    <label htmlFor="jobtype">סוג תפקיד</label>
                    <select
                      name="jobtype"
                      onChange={handleDDSChange}
                      value={newJob.jobtype}
                      className="form-control"
                    >
                      <option value="" selected>
                        בחר סוג
                      </option>
                      {jobtypesList?.map((a) => (
                        <option key={a.id} value={a.id}>
                          {a.title}
                        </option>
                      ))}
                    </select>
                  </div>
                  <br />
                  <button type="submit" className="btn btn-primary">
                    הוסף תפקיד חדש
                  </button>
                </form>
              </Col>
            </Row>
            <Row>
              <Col xs={12} sm={6}></Col>
            </Row>

            {isAdded && (
              <CustomAlert
                setShow={SetIsAdded}
                alertHeader={title}
                alertBody="התפקיד נוסף בהצלחה"
              />
            )}
          </div>
        </div>
      </center>
    </div>
  );
}
